import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const getClockAngles = (date) => {
  const seconds = date.getSeconds() + date.getMilliseconds() / 1000;
  const minutes = date.getMinutes() + seconds / 60;
  const hours = (date.getHours() % 12) + minutes / 60;

  return {
    hours: hours * 30,
    minutes: minutes * 6,
    seconds: seconds * 6,
  };
};

const Home = () => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const tick = () => setNow(new Date());
    tick();
    const timer = setInterval(tick, 1000);

    return () => clearInterval(timer);
  }, []);

  const angles = getClockAngles(now);

  return (
    <div className="home">
      <section className="hero">
        <div className="hero-title">
          <h1 className="hero-jays">Jay's</h1>
          <div className="hero-clock-area">
            <div className="hero-clock" aria-label="Handcrafted pottery clock showing local time">
              <img
                src="/images/clock-face.png"
                alt=""
                className="hero-clock-face"
              />
              <img
                src="/images/hours-hand.png"
                alt=""
                className="hero-clock-hand hero-clock-hand-hours"
                style={{ transform: `rotate(${angles.hours}deg) scale(0.35)` }}
              />
              <img
                src="/images/minutes-hand.png"
                alt=""
                className="hero-clock-hand hero-clock-hand-minutes"
                style={{ transform: `rotate(${angles.minutes}deg) scale(0.35)` }}
              />
              <img
                src="/images/seconds-hand.png"
                alt=""
                className="hero-clock-hand hero-clock-hand-seconds"
                style={{ transform: `rotate(${angles.seconds}deg) scale(0.35)` }}
              />
            </div>
          </div>
          <h1 className="hero-clays">Clays</h1>
        </div>
        <p className="hero-description">
          Jay is a Brooklyn-based ceramicist and Masters of Materials Science
          who creates one-of-a-kind, durable pottery for every occasion. Jay's Clays
          was born out of a love for natural materials, textured glazes, and lots of bowls.
        </p>
      </section>

      <section className="home-sections">
        <Link to="/ready-made" className="home-section section-right">
          <div className="section-image-wrapper section-image-sm rotate-left">
            <img src="/images/ready-to-ship.png" alt="Ready to ship pottery" />
          </div>
          <h2 className="section-title">Ready to Ship</h2>
        </Link>

        <Link to="/contact" className="home-section section-left">
          <h2 className="section-title">Custom Orders</h2>
          <div className="section-image-wrapper rotate-right">
            <img src="/images/custom-orders.png" alt="Custom order pottery" />
          </div>
        </Link>

        <Link to="/past-throws" className="home-section section-right">
          <div className="section-image-wrapper section-image-lg">
            <img src="/images/wholesale.png" alt="Wholesale pottery" />
          </div>
          <h2 className="section-title">Past Throws</h2>
        </Link>
      </section>
    </div>
  );
};

export default Home;
